import { EmptyDataMessage } from '@/common/components/EmptyDataMessage'
import { Pagination } from '@/common/components/Table/pagination'
import { CompanyEquipmentsGridLoading } from '@/features/privateCompanies/components/CompanyEquipmentGridLoading'
import { CompanyEquipmentData } from '@/features/privateCompanies/types/companyEquipments.type'
import { twMerge } from 'tailwind-merge'
import { SelectEquipmentGridItem } from './SelectEquipmentGridItem'

interface SelectEquipmentGridTableProps {
  className?: string
  companyId?: string
  companyEquipments: CompanyEquipmentData[]
  page: number
  totalPages: number
  totalCount?: number
  setPage?: React.Dispatch<React.SetStateAction<number | undefined>>
  isLoadingData: boolean
  hasSelection?: boolean
}

export const SelectEquipmentGridTable = ({
  className,
  companyId,
  companyEquipments,
  page,
  totalPages,
  totalCount,
  setPage,
  isLoadingData,
}: SelectEquipmentGridTableProps) => {
  return isLoadingData || !!companyEquipments.length ? (
    <div>
      <div
        data-testid="equipments_grid"
        className={twMerge(
          'grid grid-cols-[repeat(auto-fill,minmax(216px,1fr))] gap-4 overflow-y-auto max-h-[calc(100vh-358px)]',
          className,
        )}
      >
        {isLoadingData ? (
          Array(20)
            .fill(0)
            .map((_, index) => <CompanyEquipmentsGridLoading key={index} />)
        ) : (
          <>
            {companyEquipments.map((equipment) => (
              <SelectEquipmentGridItem
                key={equipment.id}
                companyId={companyId}
                equipment={equipment}
              />
            ))}
          </>
        )}
      </div>

      <div
        className={twMerge(
          'w-full px-4 py-2 bg-white-200 rounded-b-lg flex justify-between items-center',
          typeof totalCount === 'undefined' && 'justify-end',
        )}
      >
        {typeof totalCount !== 'undefined' ? (
          <p className="text-xs italic font-light">
            Mostrando {companyEquipments.length} resultados de {totalCount}
          </p>
        ) : null}
        {setPage && (
          <Pagination
            currentPage={Number(page)}
            setPage={setPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </div>
  ) : (
    <EmptyDataMessage className={className} />
  )
}
